import _ from 'lodash'

function numberSorter(a, b, aRow, bRow, column, dir, sorterParams) {
  // if either is undefined, treat is a 0
  return (!_.isNil(a) ? a : 0) - (!_.isNil(b) ? b : 0)
}

let stageSelect = ['Pre-Seed', 'Seed', 'Seed Extension', 'Series A', 'Series B', 'Series C', 'Series D', 'Series E', 'Series F', 'Series G', 'Series H', 'Secondary Market', 'IPO', 'Private']
let statusSelect = ['In-Active', 'Active', 'IPO', 'Acquired', 'Out of Business']
let directSelect = ['Direct', 'LP']


export { stageSelect, statusSelect, directSelect, numberSorter }
